import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getOrganizationChannel(params) {
  let url = ApiUrl.ORGANIZATIONCHANNEL;
  if (params) {
    const queryParams = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }
  return httpService.get(url);
}

const obj = { getOrganizationChannel };

export default obj;
